module.exports = __webpack_public_path__ + "static/media/index-icon.8ba28347.svg";